class TabContainer extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.shadowRoot.innerHTML = `
      <slot name="tab"></slot>
      <slot></slot>
    `;
  }

  connectedCallback() {
    this.updateTabs();
    this.openDropdown();
  }

  updateTabs() {
    const tabElements = this.querySelectorAll(".tab-header-list-name");

    tabElements.forEach((tab) => {
      tab.addEventListener("click", (event) => this.switchTab(event));
    });
  }

  switchTab(event) {
    const targetId = event.currentTarget.dataset.target;

    this.querySelectorAll(".tab-header-list-name").forEach((tab) => {
      tab.classList.remove("active");
    });
    this.querySelectorAll("tab-content").forEach((content) => {
      content.classList.remove("active");
    });

    event.currentTarget.classList.add("active");
    this.querySelector(`#${targetId}`).classList.add("active");
  }

  openDropdown() {
    const wishlistDropdownBtn = document.querySelector(
      ".tab-header-dropdown-btn"
    );
    const wishlistDropdownContent = document.querySelector(
      ".tab-header-dropdown-content"
    );

    wishlistDropdownBtn?.addEventListener("click", () => {
      wishlistDropdownContent.classList.toggle("open");
    });

    const tabElements = this.querySelectorAll(".tab-header-list-name");

    tabElements.forEach((tab) => {
      tab.addEventListener("click", (event) => {
        wishlistDropdownContent.classList.remove("open");
      });
    });
  }
}

customElements.define("tab-container", TabContainer);

// Buy all products from list
document.addEventListener("DOMContentLoaded", function () {
  const buyAllButtons = document.querySelectorAll(".buy-all-btn");

  buyAllButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();

      const productsWrapper = button
        .closest("tab-content")
        .querySelector(".wishlist-item-products");

      const products = productsWrapper.querySelectorAll(".product");

      const itemsToAdd = [];

      products.forEach((product) => {
        const variantId = product.getAttribute("data-variant-id");

        const quantityElement = product.querySelector(
          ".wishlist-product-element.antal .quantity__input"
        );
        const quantity = quantityElement ? quantityElement.value : 1;

        itemsToAdd.push({
          id: variantId,
          quantity: quantity,
        });
      });

      addToCart(itemsToAdd);
      openAddToCartModal(itemsToAdd);
    });
  });

  function addToCart(items) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: items }),
    })
      .then((response) => response.json())
      .then((data) => {
        updateCartUI();
        resetAllInputs();
      })
      .catch((error) => {
        console.error("Error adding products to cart:", error);
      });
  }

  function resetAllInputs() {
    const quantityInputs = document.querySelectorAll(".quantity__input");
    quantityInputs.forEach((input) => {
      input.value = 0;
    });
  }

  function updateCartUI() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const cartCountElement = document.querySelector(
          ".cart-count-bubble span"
        );
        const cartCountWrapper = document.querySelector("#cart-icon-bubble");
        const cartCountMarkup = `
        <div class="cart-count-bubble">
          <span aria-hidden="true">${cart.item_count}</span>
          <span class="visually-hidden">${cart.item_count} artikel</span>
        </div>`;

        if (!cartCountElement) {
          cartCountWrapper.insertAdjacentHTML("beforeend", cartCountMarkup);
        } else {
          cartCountElement.textContent = cart.item_count;
        }
      })
      .catch((error) => {
        console.error("Error updating cart UI:", error);
      });
  }

  function openAddToCartModal(items) {
    const totalQuantityEl = document.querySelector("#totalQuantityEl");

    const totalQuantity = items.reduce(
      (sum, item) => sum + parseInt(item.quantity, 10),
      0
    );

    totalQuantityEl.textContent = `Tillagd i kundvagn ${totalQuantity} produkter`;

    const modalAddToCart = document.getElementById("addToCartModalTotalEls");

    modalAddToCart.style.display = "block";

    setTimeout(function () {
      modalAddToCart.style.display = "none";
    }, 3000);
  }
});
